import React, { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import axios from 'axios';
import { FiPrinter, FiArrowLeft } from 'react-icons/fi';
import { API_BASE_URL } from '../../config';

/* ── helpers ─────────────────────────────────────── */

const DateBoxes = ({ dateStr = '' }) => {
  let d1='', d2='', m1='', m2='', y1='', y2='';
  if (dateStr) {
    const [year, month, day] = dateStr.split('T')[0].split('-');
    d1 = day?.[0]||''; d2 = day?.[1]||'';
    m1 = month?.[0]||''; m2 = month?.[1]||'';
    y1 = year?.[2]||''; y2 = year?.[3]||'';
  }
  const chars  = [d1,d2,m1,m2,y1,y2];
  const labels = ['D','D','M','M','Y','Y'];
  return (
    <div style={{ display:'flex', alignItems:'flex-end', gap:3 }}>
      {labels.map((lbl, i) => (
        <div key={i} style={{ display:'flex', flexDirection:'column', alignItems:'center' }}>
          <span style={{ fontSize:9, color:'#555', lineHeight:1, marginBottom:2 }}>{lbl}</span>
          <div style={{ width:20, height:20, border:'0.8px solid #888', display:'flex', alignItems:'center', justifyContent:'center', fontSize:12, fontFamily:'monospace', fontWeight:600 }}>
            {chars[i]}
          </div>
        </div>
      ))}
    </div>
  );
};

const CharBoxes = ({ value='', count=18 }) => {
  const str = (value||'').toString().toUpperCase();
  return (
    <div style={{ display:'flex', flexWrap:'wrap', gap:1 }}>
      {Array.from({ length: count }, (_, i) => (
        <div key={i} style={{ width:16, height:16, border:'0.7px solid #999', display:'flex', alignItems:'center', justifyContent:'center', fontSize:10, fontFamily:'monospace', fontWeight:600 }}>
          {str[i]||''}
        </div>
      ))}
    </div>
  );
};

const LABEL_W = 130;

const Field = ({ label, value='', count=18 }) => (
  <div style={{ display:'flex', alignItems:'center', marginBottom:7 }}>
    <div style={{ width:LABEL_W, fontSize:11, color:'#222', flexShrink:0 }}>{label}:</div>
    <CharBoxes value={value} count={count} />
  </div>
);

/* ── warranty table data ─────────────────────────── */
const warrantyTable = [
  { category:'LED Television',                      spare:'1 (One) Year',  after:'2 (Two) Years' },
  { category:'Audio',                               spare:'1 (One) Year',  after:'1 (One) Year'  },
  { category:'Domestic Appliances & Personal Care', spare:'2 (Two) Years', after:'2 (Two) Years' },
  { category:'Mother & Child Care',                 spare:'2 (Two) Years', after:'2 (Two) Years' },
  { category:'Accessories',                         spare:'6 Month',       after:''               },
];

/* ── component ───────────────────────────────────── */
const WarrantyPrint = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const [warranty, setWarranty] = useState(null);
  const [loading, setLoading] = useState(true);

  const token = localStorage.getItem('token');

  useEffect(() => {
    const fetch = async () => {
      try {
        const res = await axios.get(`${API_BASE_URL}/api/warranty-registrations/${id}`, {
          headers: { Authorization: `Bearer ${token}` },
        });
        let data = res.data;
        if (data.warrantyRegistration) data = data.warrantyRegistration;
        else if (data.data) data = data.data;
        setWarranty(data);
      } catch {
        // silent
      } finally {
        setLoading(false);
      }
    };
    fetch();
  }, [id, token]);

  if (loading) return <div style={{ padding:40, textAlign:'center' }}>Loading…</div>;
  if (!warranty) return <div style={{ padding:40, textAlign:'center' }}>Warranty not found.</div>;

  const purchaseDate = warranty.date_of_purchase ? warranty.date_of_purchase.split('T')[0] : '';

  const thStyle = {
    border:'1px solid #ccc', padding:'5px 8px', fontSize:11,
    textAlign:'left', backgroundColor:'#f5f5f5', fontWeight:700,
  };
  const tdStyle = {
    border:'1px solid #ccc', padding:'5px 8px', fontSize:11,
  };

  return (
    <>
      {/* Print controls — hidden when printing */}
      <div className="no-print" style={{ backgroundColor:'#f5f5f5', padding:'12px 24px', display:'flex', gap:12, alignItems:'center' }}>
        <button onClick={() => navigate(-1)} className="btn-secondary flex items-center gap-2" style={{ fontSize:13 }}>
          <FiArrowLeft size={16} /> Back
        </button>
        <button onClick={() => window.print()} className="btn-primary flex items-center gap-2" style={{ fontSize:13 }}>
          <FiPrinter size={16} /> Print
        </button>
      </div>

      {/* Print area */}
      <div style={{ padding:'24px', backgroundColor:'#f0f0f0', minHeight:'calc(100vh - 60px)' }}>
        <div style={{ width:680, margin:'0 auto', fontFamily:"'Arial', sans-serif", padding:0, backgroundColor:'#fff', fontSize:12, color:'#222' }}>

          {/* ── HEADER ── */}
          <div style={{ display:'flex', alignItems:'stretch' }}>
            <div style={{ display:'flex', alignItems:'center', gap:10, padding:'10px 14px', flex:1 }}>
              <img src="/jyoti-logo.png" alt="Jyoti" style={{ height:60, width:'auto', objectFit:'contain', flexShrink:0 }} />
              <div>
                <div style={{ fontSize:10, color:'#555', marginBottom:2 }}>Philips Consumer Care Center</div>
                <div style={{ fontSize:12, fontWeight:800, color:'#C8102E', letterSpacing:0.3 }}>SYAKAR COMPANY PVT. LTD.</div>
                <div style={{ fontSize:9, color:'#444', marginTop:3, lineHeight:1.6 }}>
                  Kantipath, Kathmandu, Nepal<br />
                  Ph: 5-325267 (Service Center), 5-348192 (Kantipath Showroom),<br />
                  5-330129 (Newroad Showroom), 5428331 (Batuk Bhairav)<br />
                  E-mail: philipsconsumercare@syakar.com.np
                </div>
              </div>
            </div>
            <div style={{ padding:'10px 20px', display:'flex', alignItems:'center' }}>
              <span style={{ fontSize:28, fontWeight:900, color:'#0A5C8E', letterSpacing:2, fontFamily:'Arial Black, Arial' }}>PHILIPS</span>
            </div>
          </div>

          {/* ── MAIN BODY ── */}
          <div style={{ display:'flex', marginTop:10 }}>

            {/* Left column — form data */}
            <div style={{ flex:1, padding:'0 14px 12px' }}>
              <div style={{ display:'flex', alignItems:'center', marginBottom:7 }}>
                <div style={{ width:LABEL_W, fontSize:11, color:'#222', flexShrink:0 }}>Date of Purchase:</div>
                <DateBoxes dateStr={purchaseDate} />
              </div>
              <Field label="Model Number"     value={warranty.model_no}      count={16} />
              <Field label="Invoice No"       value={warranty.invoice_no}    count={16} />
              <Field label="Customer Name"    value={warranty.customer_name} count={20} />
              <Field label="Customer Address" value={warranty.address}       count={20} />

              <div style={{ marginTop:10 }}>
                <div style={{ fontSize:11, color:'#222', marginBottom:5 }}>
                  Product Serial Number (Barcode):
                </div>
                <div style={{ height:38, border:'0.8px solid #999', display:'flex', alignItems:'center', padding:'0 8px', fontSize:13, fontFamily:'monospace', fontWeight:600, letterSpacing:2 }}>
                  {warranty.serial_no || ''}
                </div>
              </div>
            </div>

            {/* Right column — customer copy */}
            <div style={{ width:180, padding:'0 14px 12px', display:'flex', flexDirection:'column', alignItems:'flex-start', gap:10 }}>
              <div style={{ fontSize:14, fontWeight:700, color:'#222' }}>
                Customer Copy
              </div>
              <div style={{ fontSize:11, color:'#555' }}>SN:</div>
              {/* Warranty SN — font size intentionally unchanged */}
              <div style={{ fontSize:16, fontWeight:900, color:'#C8102E', fontFamily:'Arial Black, Arial', lineHeight:1, marginTop:4 }}>
                {warranty.warranty_sn || ''}
              </div>
            </div>
          </div>

          {/* ── WARRANTY RULES ── */}
          <div style={{ padding:'10px 14px' }}>
            <div style={{ fontWeight:800, fontSize:13, textAlign:'center', marginBottom:6 }}>
              Warranty Rules &amp; Regulations
            </div>
            <p style={{ fontSize:11, lineHeight:1.7, margin:0, marginBottom:8 }}>
              Syakar Company Pvt. Limited warrants to the purchaser of this original{' '}
              <strong>PHILIPS</strong> product that, it is free from defects in material and workmanship.
            </p>
            <div style={{ display:'flex', alignItems:'center', gap:10 }}>
              <div style={{ fontSize:11, flex:1 }}>Warranty Applicable from the Date of Purchase:</div>
              <DateBoxes dateStr={purchaseDate} />
            </div>
          </div>

          {/* ── TABLE ── */}
          <div style={{ padding:'0 14px 10px' }}>
            <table style={{ width:'100%', borderCollapse:'collapse', marginTop:10 }}>
              <thead>
                <tr>
                  <th style={thStyle}>Product Category Type</th>
                  <th style={{ ...thStyle, textAlign:'center' }}>Spare Parts</th>
                  <th style={{ ...thStyle, textAlign:'center' }}>After Sales Service</th>
                </tr>
              </thead>
              <tbody>
                {warrantyTable.map((row, i) => (
                  <tr key={i}>
                    <td style={tdStyle}>{row.category}</td>
                    <td style={{ ...tdStyle, textAlign:'center' }}>{row.spare}</td>
                    <td style={{ ...tdStyle, textAlign:'center' }}>{row.after}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>

          {/* ── FINE PRINT ── */}
          <div style={{ padding:'0 14px 14px' }}>
            <p style={{ fontSize:10, lineHeight:1.7, color:'#333', margin:0 }}>
              During the specified warranty period, all functional parts of the product, which proves
              to be defective in material and workmanship will be replaced free of charges upon
              presenting this warranty card. Should free repair be required during the specific warranty
              period, the product must be taken or delivered to the nearest company authorized service center.
            </p>
          </div>

        </div>
      </div>

      <style>{`
        @media print {
          .no-print { display: none !important; }
          body { margin: 0; background: #fff; }
          @page { size: A4; margin: 10mm; }
        }
      `}</style>
    </>
  );
};

export default WarrantyPrint;
